import React from 'react';

function WardrobeIntro(props){
    return(
        <div className="wardrobeIntro mt-sm-5 mb-md-5 pt-3 pt-md-5 pb-5">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 col-sm-9 col-md-8">
                        <div className="textModule1 text-sm-center" dangerouslySetInnerHTML={{__html: props.content}}>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default WardrobeIntro;